var _rect, _rect2, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSizemdPaymentmethodKlarna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 32,
    viewBox: "0 0 46 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    fill: "#FEB4C7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 45,
    height: 31,
    rx: 3.5,
    stroke: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.02554 20.5062H5.18091V12H7.02554V20.5062ZM11.6308 12H9.8262C9.8262 13.5654 9.14615 15.0021 7.96049 15.9421L7.24552 16.5087L10.0158 20.5065H12.2934L9.74445 16.8279C10.9527 15.5546 11.6308 13.8415 11.6308 12ZM14.573 20.5038H12.831V12.0016H14.573V20.5038ZM19.8363 14.6225V14.9987C19.3662 14.6594 18.7989 14.4599 18.187 14.4599C16.5675 14.4599 15.2546 15.8494 15.2546 17.5633C15.2546 19.2772 16.5675 20.6667 18.187 20.6667C18.7989 20.6667 19.3662 20.4672 19.8363 20.128V20.5038H21.5002V14.6225H19.8363ZM19.8313 17.5633C19.8313 18.399 19.1562 19.0766 18.3236 19.0766C17.491 19.0766 16.8159 18.399 16.8159 17.5633C16.8159 16.7276 17.491 16.0503 18.3236 16.0503C19.1562 16.0503 19.8313 16.7276 19.8313 17.5633ZM37.3897 14.9987V14.6225H39.0536V20.5038H37.3897V20.128C36.9197 20.4672 36.3523 20.6667 35.7403 20.6667C34.1208 20.6667 32.808 19.2772 32.808 17.5633C32.808 15.8494 34.1208 14.4599 35.7403 14.4599C36.3523 14.4599 36.9197 14.6594 37.3897 14.9987ZM35.8769 19.0766C36.7096 19.0766 37.3846 18.399 37.3846 17.5633C37.3846 16.7276 36.7096 16.0503 35.8769 16.0503C35.0443 16.0503 34.3693 16.7276 34.3693 17.5633C34.3693 18.399 35.0443 19.0766 35.8769 19.0766ZM39.7757 19.5229C39.7757 18.9125 40.2431 18.4178 40.8197 18.4178C41.3964 18.4178 41.8639 18.9125 41.8639 19.5229C41.8639 20.133 41.3964 20.6278 40.8197 20.6278C40.2431 20.6278 39.7757 20.133 39.7757 19.5229ZM29.8513 14.4643C29.1866 14.4643 28.5576 14.6827 28.1371 15.2852V14.6229H26.4804V20.5038H28.1574V17.4132C28.1574 16.5188 28.7241 16.0809 29.4064 16.0809C30.1377 16.0809 30.5581 16.5432 30.5581 17.401V20.5038H32.22V16.7638C32.22 15.3951 31.1917 14.4643 29.8513 14.4643ZM24.0741 14.6226V15.3886C24.4076 14.9291 25.0291 14.623 25.7048 14.623V16.3343L25.6955 16.3339C25.692 16.3338 25.6886 16.3336 25.685 16.3336C25.0267 16.3336 24.0779 16.8315 24.0779 17.758V20.5039H22.3706V14.6226H24.0741Z",
    fill: "#17120F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSizemdPaymentmethodKlarna);
export default __webpack_public_path__ + "static/media/Size=md, Payment method=Klarna.a51034d8.svg";
export { ForwardRef as ReactComponent };